import RcPagination from 'rc-pagination'
import { ReactNode } from 'react'
import cn from 'classnames'
import Router from 'next/router'

import { PaginationProps } from '@components/Pagination/interface'
import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { ArrowLeftIcon } from '@components/icons/ArrowLeftIcon'
import { ArrowRightIcon } from '@components/icons/ArrowRightIcon'

const itemRender = (
  current: number,
  type: 'page' | 'prev' | 'next' | 'jump-prev' | 'jump-next',
  element: ReactNode,
  page: number,
  totalPage: number
) => {
  if (type === 'page') {
    return (
      <div>
        {current === totalPage && totalPage > 1 ? (
          <>
            <span className='mx-[20px] mobile:hidden'>หน้าสุดท้าย</span>
            <span className='desktop-tablet:hidden'>{totalPage}</span>
          </>
        ) : (
          current
        )}
      </div>
    )
  }
  if (type === 'prev') {
    return (
      <div className='h-[30px] flex px-[3px] items-center justify-center rounded-[8px] mobile:rounded-[20px]'>
        <ArrowLeftIcon />
      </div>
    )
  }
  if (type === 'next') {
    return (
      <div className='h-[30px] flex px-[3px] items-center justify-center rounded-[8px] mobile:rounded-[20px]'>
        <ArrowRightIcon />
      </div>
    )
  }
  return element
}

export function Pagination({
  page,
  total,
  perpage,
  pageChange,
  totalPage,
}: PaginationProps) {
  const { isDarkTheme, isNightTheme, isNightOrDarkTheme } = useTheme()

  return (
    <div
      className={cn('flex justify-center', {
        'night-mode':
          isNightTheme ||
          (isNightOrDarkTheme &&
            Router.pathname !== '/story/[id]/chapter/[chapterId]'),
        'dark-mode':
          isDarkTheme && Router.pathname === '/story/[id]/chapter/[chapterId]',
      })}
    >
      <RcPagination
        onChange={pageChange}
        pageSize={perpage}
        current={page}
        total={total}
        itemRender={(current, type, element) =>
          itemRender(current, type, element, page, totalPage)
        }
        showTitle={false}
        showLessItems
      />
    </div>
  )
}
